<template>
  <div class="profile" v-if="profile">
    <van-nav-bar
      title="个人信息"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="title">手机号</div>
    <van-cell-group>
      <van-field
        v-model="profile.mobile"
        disabled
        type="tel"
        label="手机"
        placeholder="绑定手机号"
        @click.native="onBind"
      />
    </van-cell-group>

    <div class="title">基础信息</div>

    <div class="headimg-warp">
      <div>上传个人头像</div>
      <van-uploader :after-read="onHeadimgRead">
        <div class="headimg-uploader">
          <img v-lazy="headimg" class="headimg">
          <div class="btn">更换图片</div>
        </div>
      </van-uploader>
    </div>

    <van-cell-group>
      <van-field
        v-model="profile.nickname"
        clearable
        label="昵称"
        placeholder="请输入昵称"
      />
      <gender-picker v-model="profile.sex" />
      <date-picker title="出生日期" v-model="profile.birthday" />
      <!-- <city-picker v-model="profile.city"/> -->
      <!-- <div class="check_len_textarea">
        <van-field
          v-model="profile.intro"
          clearable
          class="field"
          type="textarea"
          label="个人简介"
          placeholder="请输入个人简介"
          :maxlength="introMaxLen"
        />
        <div class="check_label">
          {{ introLen }}/{{ introMaxLen }}
        </div>
      </div> -->
    </van-cell-group>

    <bottom-btn class="bgwhite" title="保存" :fixed="false" @click.native="gotoSave" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Field, Cell, CellGroup, Toast, NavBar, Uploader } from 'vant'
import GenderPicker from '@/components/Picker/GenderPicker'
import DatePicker from '@/components/Picker/DatePicker'
import CityPicker from '@/components/Picker/CityPicker'
import BottomBtn from '@/components/BottomBtn'
import { strLength } from '@/utils/index'
import { editUserInfo } from '@/api/account'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams } from '@/utils/upload'

export default {
  name: 'Profile',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    GenderPicker,
    DatePicker,
    CityPicker,
    BottomBtn
  },
  data () {
    return {
      introLen: 0,
      introMaxLen: 100,
      uploadHeadimgObj: null,
      profile: null
    }
  },
  watch: {
    profile: {
      handler (profile) {
        this.introLen = profile && profile.intro ? strLength(profile.intro) : 0
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'userprofile',
      'ossToken'
    ]),
    headimg () {
      return this.uploadHeadimgObj ? this.uploadHeadimgObj.content : this.userprofile.avatar_url
    }
  },
  created () {
    this.profile = {
      nickname: this.userprofile.nickname,
      mobile: this.userprofile.is_bind_mobile ? this.userprofile.mobile : '',
      sex: this.userprofile.sex,
      birthday: this.userprofile.birthday_format
      // city: this.userprofile.city,
      // intro: this.userprofile.intro
    }
  },
  methods: {
    async gotoSave () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      if (this.uploadHeadimgObj) {
        this.profile.avatar = await this.uploadHeadimg(this.uploadHeadimgObj.file)
      }

      await editUserInfo(this.profile)
      await this.$store.dispatch('GetUserInfo')
      Toast.clear()
      this.$router.push('/my')
    },
    onBind () {
      if (!this.userprofile.is_bind_mobile) {
        this.$router.push('/bind/mobile?path=' + encodeURIComponent(this.$route.fullPath))
      }
    },
    onHeadimgRead (file) {
      this.uploadHeadimgObj = file
    },
    async uploadHeadimg (fileObj) {
      await this.$store.dispatch('GetOssToken', 'headimg')
      const formData = getUploadParams(this.ossToken, fileObj)

      await uploadImageToOss(this.ossToken.host, formData)
      return formData.get('key')
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.profile {
  background-color: #f8f8f8;
  .headimg-warp {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    background-color: #fff;
    padding: 30px 30px 30px 30px;
  }
  .headimg-uploader {
    position: relative;
    .headimg {
      width: 130px;
      height: 130px;
      object-fit: cover;
      margin-left: 30px;
      // border-radius: 50%;
    }
    .btn {
      width: 130px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000;
      color: #fff;
      opacity: 0.6;
      font-size: 24px;
      position: absolute;
      bottom: 0;
      left: 30px;
    }
  }
  .title {
    font-size: 28px;
    color: rgba(69,90,100,.6);
    padding: 15px 0 15px 20px;
  }
}
</style>
